import { ToolPageShell } from '@/shared/seo'
import { PdfPageImagesForm } from '@/features/pdf-page-images'

export function PdfVPngPage() {
  return (
    <ToolPageShell utilityKey="pdf-to-png">
      <PdfPageImagesForm outputFormat="png" />
    </ToolPageShell>
  )
}
